module.exports = __webpack_public_path__ + "static/media/armenia.3f00758e.mp4";